import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    devices: [],
    alarms: [],
    rules: [],
    statistics: {}
  },
  mutations: {
    SET_DEVICES(state, devices) {
      state.devices = devices
    },
    SET_ALARMS(state, alarms) {
      state.alarms = alarms
    },
    SET_RULES(state, rules) {
      state.rules = rules
    },
    SET_STATISTICS(state, statistics) {
      state.statistics = statistics
    }
  },
  actions: {
    setDevices({ commit }, devices) {
      commit('SET_DEVICES', devices)
    },
    setAlarms({ commit }, alarms) {
      commit('SET_ALARMS', alarms)
    },
    setRules({ commit }, rules) {
      commit('SET_RULES', rules)
    },
    setStatistics({ commit }, statistics) {
      commit('SET_STATISTICS', statistics)
    }
  }
})
